/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Col, Modal, Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "../../../assets/style/table/deals.scss";
import { dealSelector } from "../../../services/selector/index.";
import {
  IconDetail,
  IconEdit,
  IconEye,
  IconLock,
  IconNext,
  IconPlus,
  IconPre,
  IconSpin,
  IconXmark,
} from "../../../assets/icon";
import { useMemo } from "react";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import TranslateText from "../TranslateText";
import { renameLimitDeal, renameTypeDeal } from "../../../utils/convertNumber";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  getAllDeals,
  getLogDeal,
  setOpenDetailDeals,
  setOpenEditDeals,
  setPage,
  setDataAreaOne,
  postPin,
  setLimitDeals,
  setStatusDeals,
  setOpenModalPostDeals,
  setSearchText,
} from "../../../services/slice/DealSlice";
import { formatDate } from "../../../utils/functionCommon";
import { useCookies } from "react-cookie";
import { useRef } from "react";
import InputSearchBox from "../Input/InputSearchBox";
import SelectValue from "../Selector/SelectValue";
import { valueSelectStatusDeals } from "../../../utils/ValueSelect";
import BaseButton from "../Button/BaseButton";
import NoSearchResults from "../NoSearchResults";

const TableDeal = ({ valueSelectTimeGroup }) => {
  const { t } = useTranslation();
  const dealData = useSelector(dealSelector);
  const {
    data,
    total,
    config,
    callBackRequest,
    isLoading,
    dataAreaOne,
    // dataAreaTwo,
    dataAreaTwo,
  } = dealData;
  const [openModalImagePin, setOpenModaImagPin] = useState(false);
  const { option } = config;
  const dispatch = useDispatch();
  const dealState = useSelector(dealSelector);
  const [valuePin, setValuePin] = useState({
    id: "",
    type: "",
  });
  const [rightClick, setRightClick] = useState({
    isOpen: false,
    x: "",
    y: "",
    value: "",
  });
  const handleRightClick = (e, record) => {
    e.preventDefault();
    setValuePin({
      ...valuePin,
      id: record.id,
    });
    setRightClick({
      isOpen: true,
      x: e.clientX,
      y: e.clientY - 70,
      value: record,
    });
  };
  useEffect(() => {
    dispatch(getAllDeals(config));
  }, [dispatch, config]);
  useEffect(() => {
    if (callBackRequest) {
      dispatch(getAllDeals());
    }
  }, [callBackRequest, dispatch]);
  const dataSource = useMemo(() => {
    let result = [];
    result = data?.map((item, index) => {
      return {
        ...item,
        key: item.id,
        status: t(renameTypeDeal(item.status)),
        limit: renameLimitDeal(item.typePreferential),
        timeStart: formatDate(item.timeStart),
        timeEnd: formatDate(item.timeEnd),
        timeCreate: formatDate(item.timeCreate),
        STT:
          total > 10 && option.offset >= 2
            ? (option.offset - 1) * 10 + index + 1
            : index + 1,
      };
    });
    return result;
  }, [data, option.offset, t, total]);

  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 60,
    },
    {
      title: <TranslateText text="Tiêu đề" />,
      dataIndex: "title",
      key: "title",
      className: "title pointer",
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <Tooltip placement="topLeft" title={value}>
          {value}
        </Tooltip>
      ),
    },
    {
      title: <TranslateText text="Đối tượng" />,
      dataIndex: "typePreferential",
      key: "typePreferential",
      className: "limit centerCell",
      render: (text, record) => {
        if (text === 0) {
          return "Toàn bộ KH";
        } else if (text === 1) return "KH thuộc đại lý";
        else return "KH Online";
      },
    },
    {
      title: <TranslateText text="Thời gian bắt đầu KM" />,
      dataIndex: "timeStart",
      key: "timeStart",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Thời gian kết thúc KM" />,
      dataIndex: "timeEnd",
      key: "timeEnd",
      className: "centerCell",
    },

    {
      title: <TranslateText text="Trạng thái" />,
      key: "status",
      dataIndex: "status",
      className: "centerCell",
      // className: "evenSpace",
    },
    {
      title: <TranslateText text="Thời gian tạo" />,
      dataIndex: "timeCreate",
      key: "timeCreate",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "evenSpace",
      render: (text, record) => {
        return (
          <div className="evenSpace" style={{ minWidth: "120px" }}>
            <span
              className="pointer iconTbl"
              onClick={() => dispatch(getLogDeal(record.id))}
            >
              <Tooltip title="Xem log">
                <IconLock />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl"
              onClick={() =>
                dispatch(setOpenDetailDeals({ isOpen: true, id: record.id }))
              }
            >
              <Tooltip title="Xem chi tiết">
                <IconDetail />
              </Tooltip>
            </span>

            <span
              className="pointer iconTbl"
              onClick={() =>
                dispatch(setOpenEditDeals({ isOpen: true, id: record.id }))
              }
            >
              <Tooltip title="Chỉnh sửa">
                <IconEdit />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl"
              onClick={() =>
                dispatch(
                  setOpenPUDelete({
                    stateOpen: true,
                    content: record.title,
                    id: record.id,
                  })
                )
              }
            >
              <Tooltip title="Xóa">
                <IconXmark />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];

  const tableLoading = {
    spinning: isLoading, // isLoading là biến boolean để xác định xem có đang loading hay không
    indicator: <IconSpin className="iconSpin" />,
  };
  const rowClassName = (record) => {
    return record.statusPin ? "marked-row" : "";
  };
  return (
    <div>
      {/* {openModalImagePin ? (
        <ModalEditImagePin
          isOpen={openModalImagePin}
          value={valuePin}
          setIsOpen={setOpenModaImagPin}
        />
      ) : null} */}
      {rightClick.isOpen ? (
        <ModalRightClick
          setValuePin={setValuePin}
          top={rightClick.y}
          left={rightClick.x}
          setOpenModaImagPin={setOpenModaImagPin}
          setOpen={setRightClick}
          value={rightClick.value}
        />
      ) : null}
      <Row style={{ width: "100% " }}>
        <Col className="mr-5">
          <InputSearchBox
            width={435}
            setText={(value) => {
              dispatch(setSearchText(value));
            }}
            placeholder="Tìm kiếm theo tiêu đề"
            key={"searchDeal"}
          />
        </Col>
        <Col className="mr-5">
          <span
            style={{
              marginRight: "1rem",
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            Đối tượng:
          </span>
          <SelectValue
            width={170}
            handleChange={(value) => dispatch(setLimitDeals(value))}
            optionsValue={valueSelectTimeGroup}
            defaultValue="Tất cả"
            type={"selectGray"}
          />
        </Col>
        <Col>
          <span
            style={{
              marginRight: "1rem",
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            Trạng thái:
          </span>
          <SelectValue
            width={150}
            handleChange={(value) => dispatch(setStatusDeals(value))}
            optionsValue={valueSelectStatusDeals}
            defaultValue="Tất cả"
            type={"selectGray"}
          />
        </Col>
        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            handleClick={() => {
              dispatch(setOpenModalPostDeals(true));
            }}
            icon={
              <IconPlus
                width={16}
                height={14}
                style={{ marginRight: "0.5rem" }}
              />
            }
            content={`Thêm mới`}
            width={120}
            typeBtn="btnOrange"
          />
        </Col>
      </Row>
      {dealState.config.search && !dealState.data ? (
        <Row style={{ width: "100%" }}>
          {" "}
          <NoSearchResults />
        </Row>
      ) : (
        <Row style={{ width: "100%" }}>
          <Table
            loading={tableLoading}
            className="wrapperTblNewsPost"
            style={{ width: "100%", marginTop: "2.6rem" }}
            columns={columns}
            rowClassName={rowClassName}
            onRow={(record, index) => ({
              onContextMenu: (event) => handleRightClick(event, record),
            })}
            dataSource={dataSource}
            pagination={
              total > 10
                ? {
                    onChange: (value) => dispatch(setPage(value)),
                    total,
                    pageSize: 10,
                    current: option.offset,
                    prevIcon: <IconPre />,
                    nextIcon: <IconNext />,
                    showSizeChanger: false,
                  }
                : false
            }
          />
        </Row>
      )}
    </div>
  );
};

export default TableDeal;

const ModalRightClick = ({
  top,
  left,
  setOpen,
  value,
  setOpenModaImagPin,
  setValuePin,
}) => {
  const puRef = useRef();
  const dealData = useSelector(dealSelector);
  const { dataAreaOne, dataAreaTwo } = dealData;
  const dispatch = useDispatch();
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(puRef);
  const handleAddAreaOne = () => {
    if (dataAreaOne.find((item) => item.id === value.id)) {
      Modal.error({
        className: "wrapperModalErrConfigBanner",
        centered: true,
        width: 590,
        title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,
        content: (
          <>
            <p style={{ fontSize: 20 }}>
              Bài viết đã có trong danh sách. Vui lòng thử lại.
            </p>
          </>
        ),
      });
      return;
    }

    setOpen(false);
    const formData = new FormData();
    formData.append("preferentialID", value.id);
    formData.append("type", 1);
    dispatch(postPin(formData));
  };
  // const handleAddAreaTow = () => {
  //   if (dataAreaOne.find((item) => item.id === value.id)) {
  //     Modal.error({
  //       className: "wrapperModalErrConfigBanner",
  //       centered: true,
  //       width: 590,
  //       title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,
  //       content: (
  //         <>
  //           <p style={{ fontSize: 20 }}>
  //             Bài viết đã có trong danh sách. Vui lòng thử lại.
  //           </p>
  //         </>
  //       ),
  //     });
  //     return;
  //   }
  //   setValuePin((pre) => ({ ...pre, type: 2 }));
  //   setOpenModaImagPin(true);
  //   setOpen(false);
  // };

  return (
    <div
      ref={puRef}
      style={{ position: "absolute", top: top, left: left }}
      className="btnAddToArea"
    >
      <div className="btnAddAreaOne" onClick={handleAddAreaOne}>
        Thêm vào danh sách <span>Vị trí nổi bật</span>
      </div>
      {/* <div className="btnAddAreaOne" onClick={handleAddAreaTow}>
        Thêm vào danh sách <span>Vùng 2</span>
      </div> */}
    </div>
  );
};
